import React, {useEffect} from "react"
import { Grid, InvestmentForm } from "../components"
import { Navbar, Footer } from "../layouts"




const InvestForm = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
          });
    }, [])

    return (
        <>
        <Navbar/>
        <Grid/> 
        <InvestmentForm/>
        <Footer/>
        </>

    )
}

export default InvestForm